<div class="MainContainer animated fadeIn">
    <div class="MainCompanyTitle" style="margin-bottom: 0;">
        <p class="SectionTitle" style="margin-top: 0%;">{{ 'DashMenu.SettingsMenu.CompanySettings' | translate }} {{this.parent.Company.Name}}</p>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowANAFRedirectionNotification">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowANAFRedirectionNotification = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'ShowANAFRedirectionNotification' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'ShowANAFRedirectionNotificationDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowANAFRedirectionNotification = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ResetANAFAuthCodeAndEToken();">{{ 'ANAFRedirectionNotificationButton' | translate }}</button>
      </div>
    </div>
    
    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteSMTPQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeleteSMTPQuestion = false; currentSpending = null;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteSMTPQuestion = false; CurrenctSMTP = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteSMTPQuestion = false;DeleteSMTP(CurrenctSMTP.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>
    
    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteSMTPEmailQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeleteSMTPEmailQuestion = false; currentSpending = null;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteSMTPEmailQuestion = false; CurrenctSMTPEmail = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteSMTPEmailQuestion = false;DeleteSMTPEmail(CurrenctSMTPEmail.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="BulkDeleteMasterContainer" *ngIf="ShowBulkDeleteMasterContainer">
      <div class="PopUpCloseContainer" (click)="ShowBulkDeleteMasterContainer = false;">
        <i class="material-icons">close</i>
      </div>

      <div class="PopUpTitleContainer">
        <p style="color: #0082e6;">{{'DeletingMasterEntities' | translate}}</p>
       </div>

       <div class="PopUpBody" style="margin-top: 20px;">
        <div class="DeleteMasterRow" *ngFor="let e of this.DeletingMasterEntities; let i=index;">
          <p class="DocumentCategory">{{'Type' | translate}}: <span style="color: #2CA70F;">{{e.DocumentCategory.Name}}</span></p>
          <p class="DocumentCategory">{{'TotalDetected' | translate}}: <span style="color: #0082e6;">{{e.Filter.Pager.TotalCount}}</span></p>
          <i (click)="GetDeletingEntities(e);" class="material-icons DocumentCategoryIcon" matTooltip="{{ 'ViewDetails' | translate }}" matTooltipClass='neutral-tool-tip'>open_in_browser</i>
        </div>
      </div>

      <div class="PopUpCommands">
        <button (click)="this.OpenMFA();" [disabled]="parent.loading" mat-raised-button color="warn" matTooltip="{{ 'DeleteDataButtonDesc' | translate }}" matTooltipClass='neutral-tool-tip' class="PopGeneralCommandButton">
            <span>{{'DeleteDataButton' | translate}}</span>
      </button>
      </div>
    </div>

    <div class="BulkDeleteMasterContainer" *ngIf="ShowDeletingMasterEntitiesErrorResults">
      <div class="PopUpCloseContainer" (click)="ShowDeletingMasterEntitiesErrorResults = false;">
        <i class="material-icons">close</i>
      </div>

      <div class="PopUpTitleContainer">
        <p style="color: #0082e6;">{{'ErrorList' | translate}}</p>
       </div>

       <div class="PopUpBody" style="margin-top: 20px;">
        <div class="DeleteMasterRow" *ngFor="let e of this.ErrorsList;" style="cursor: default;" (click)="OpenDeletingEntitiesErrors(e);">
          <p class="DocumentCategory">{{'Type' | translate}}: <span style="color: #2CA70F;">{{e.DocumentCategory.Name}}</span></p>
          <p class="DocumentCategory">{{'TotalDetected' | translate}}: <span style="color: #0082e6;">{{e.Filter.Pager.TotalCount}}</span></p>
          <i class="material-icons DocumentCategoryIcon" style="color: red;">error_outline</i>
        </div>
      </div>

      <div class="PopUpCommands">
        <button (click)="ShowDeletingMasterEntitiesErrorResults = false;" [disabled]="parent.loading" mat-raised-button color="primary" matTooltipClass='neutral-tool-tip' class="PopGeneralCommandButton">
            <span>{{'Confirm' | translate}}</span>
      </button>
      </div>
    </div>

    <div class="BulkDeleteMasterContainer" *ngIf="ShowDeletingMasterEntitiesErrorResultsDetails">
      <div class="PopUpCloseContainer" (click)="ShowDeletingMasterEntitiesErrorResultsDetails = false;ShowDeletingMasterEntitiesErrorResults = true;">
        <i class="material-icons">close</i>
      </div>

      <div class="PopUpTitleContainer">
        <p style="color: #0082e6;">{{'DeletingMasterEntities' | translate}}</p>
       </div>

       <div class="PopUpBody" style="margin-top: 20px;">
        <div class="DeleteMasterRow" *ngFor="let doc of this.SelectedDeletingMasterEntity.Documents; let i=index;" matTooltip="{{doc.ErrorMessage}}" matTooltipClass='neutral-tool-tip'>
          <p class="DocumentCategory">{{SelectedDeletingMasterEntity.DocumentCategory.Name}}: <span style="color: red;">{{doc.DisplayValue}} {{'FromWord' | translate}} {{doc.EventDate}}</span></p>
          <i class="material-icons DeleteMasterRowDeleteSign" style="color: red;">error_outline</i>
        </div>
      </div>

      <div class="PopUpCommands">
        <button (click)="ShowDeletingMasterEntitiesErrorResultsDetails = false;ShowDeletingMasterEntitiesErrorResults = true;" [disabled]="parent.loading" mat-raised-button color="primary" class="PopGeneralCommandButton">
          <span>{{'Confirm' | translate}}</span>
        </button>
      </div>

    </div>

    <div class="BulkDeleteMasterContainer EntitiesContainer" *ngIf="DeletingEntitiesMasterContainer">
      <div class="PopUpCloseContainer" (click)="DeletingEntitiesMasterContainer = false;ShowBulkDeleteMasterContainer = true;">
        <i class="material-icons">close</i>
      </div>

      <div class="PopUpTitleContainer">
        <p style="color: #0082e6;">{{'DeletingMasterEntities' | translate}}</p>

        <div class="TotalDocCountContainer">
          <span style="float: right;">{{this.SelectedDeletingMasterEntity.Documents.length}} {{'OfWord' | translate}} {{this.SelectedDeletingMasterEntity.Filter.Pager.TotalCount}} {{SelectedDeletingMasterEntity.DocumentCategory.Name}} ({{'Page' | translate}}: {{this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.SelectedDeletingMasterEntity.Filter.Pager.Pages}})</span>
          <div class="PageSizeContainer">
            <mat-form-field appearance="outline" class="PageSizeTextBox">
              <mat-label>{{ 'PageSize' | translate }}*</mat-label>
              <input matInput autocomplete="off" [(ngModel)]="SelectedDeletingMasterEntity.Filter.Pager.PageSize" (change)="GetDeletingEntities(SelectedDeletingMasterEntity);">
            </mat-form-field>
          </div>
        </div>

        <div class="TotalDocCountContainer">
          <div class="TopPagingButton unSelectable" *ngIf="this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex != 1;" (click)="this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex = this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex - 1;GetDeletingEntities(SelectedDeletingMasterEntity);">
            <i class="material-icons">chevron_left</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_left</i>
          </div>

          <div class="TopPagingButton unSelectable" *ngIf="this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex != this.SelectedDeletingMasterEntity.Filter.Pager.Pages;" (click)="this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex = this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex + 1;GetDeletingEntities(SelectedDeletingMasterEntity);">
            <i class="material-icons">chevron_right</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex == this.SelectedDeletingMasterEntity.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_right</i>
          </div>
        </div>

       </div>

       <div class="PopUpBody" style="margin-top: 20px;">
        <div class="DeleteMasterRow" *ngFor="let doc of this.SelectedDeletingMasterEntity.Documents; let i=index;" [ngClass]="{'leftOutRow': doc.IsSelected == false}" (click)="SelectDeselectDeletingDocument(doc, SelectedDeletingMasterEntity.DocumentCategory.ID);">
          <p class="DocumentCategory">{{SelectedDeletingMasterEntity.DocumentCategory.Name}}: <span style="color: #2CA70F;">{{doc.DisplayValue}} {{'FromWord' | translate}} {{doc.EventDate}}</span></p>
          <i class="material-icons DeleteMasterRowDeleteSign" *ngIf="doc.IsSelected">close</i>
        </div>
      </div>

      <div class="PopUpCommands">
        <button (click)="DeletingEntitiesMasterContainer = false;ShowBulkDeleteMasterContainer = true;" [disabled]="parent.loading" mat-raised-button color="accent" class="PopGeneralCommandButton">
          <span>{{'Confirm' | translate}}</span>
        </button>
      </div>

    </div>

    <div class="example-form animated fadeInDown" *ngIf="this.ShowMFA" style="background: #fff;left: 35%;">
  
      <button [disabled]="loadingMFA" mat-raised-button (click)="this.ShowMFA = false;this.ShowBulkDeleteMasterContainer = true;">{{ 'Login.BackButton' | translate }}</button>
      <p class="LoginFormTitle">{{ 'EnterToken' | translate }}</p>
  
      <div class="MFAImage">
        <svg class="MFAImageSVG" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid"><path d="M256 127.998C256 198.696 198.694 256 127.997 256 57.304 256 0 198.696 0 127.998 0 57.305 57.304 0 127.997 0 198.694 0 256 57.305 256 127.998z" fill="#EC1C24"/><path d="M117.024 100.89l30.691 30.68c4.43 4.436 11.623 4.436 16.064 0 4.431-4.435 4.441-11.622 0-16.058L133.086 84.82C111.125 62.854 75.631 62.5 53.204 83.704a9.536 9.536 0 0 0-.605.548c-.098.098-.178.202-.275.29-.1.096-.202.182-.297.278-.194.193-.371.396-.54.597-21.215 22.437-20.85 57.932 1.113 79.897L83.292 196c4.44 4.433 11.623 4.433 16.062 0 4.442-4.437 4.442-11.633.011-16.06l-30.693-30.691c-13.398-13.393-13.488-35.129-.278-48.637 13.506-13.21 35.23-13.114 48.63.279zm39.612-40.873c-4.435 4.437-4.435 11.623.012 16.059l30.681 30.693c13.39 13.392 13.477 35.125.268 48.636-13.51 13.2-35.227 13.112-48.623-.282l-30.692-30.689c-4.438-4.437-11.633-4.437-16.066 0-4.443 4.433-4.443 11.642 0 16.065l30.682 30.694c21.968 21.965 57.458 22.322 79.889 1.116.208-.184.404-.355.61-.549.094-.095.182-.192.273-.29.1-.095.197-.183.29-.289.197-.183.365-.384.54-.594 21.215-22.428 20.86-57.911-1.102-79.889l-30.692-30.682c-4.436-4.443-11.638-4.443-16.07.001z" fill="#FFF"/></svg>
      </div>
  
      <mat-form-field appearance="outline" style="width: 100%;">
        <input autocomplete="off" class="MFATokenTextBox" [disabled]="loading" matInput placeholder="{{ 'MFAToken' | translate }}" value="" [(ngModel)]="this.MFAToken" required>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 100%;">
        <input autocomplete="off" class="MFATokenTextBox" [disabled]="loading" matInput placeholder="{{ 'PIN' | translate }}" value="" [(ngModel)]="this.parent.AppPIN" required>
      </mat-form-field>
  
          <button [disabled]="loadingMFA" mat-raised-button color="accent" class="tokenButton" (click)="this.GetMFAResult();">
            <i class="material-icons ButtonCenterImage">check</i>
            <span>{{ 'VerifyToken' | translate }}</span>
          </button>
        <mat-progress-bar mode="indeterminate" *ngIf="loadingMFA" class="loginIntermediateProgressBar"></mat-progress-bar>
    </div>

    <div class="example-form animated fadeInDown" *ngIf="this.ShowMFACompanyDelete" style="background: #fff;left: 35%;">
  
      <button [disabled]="loadingMFA" mat-raised-button (click)="this.ShowMFACompanyDelete = false;">{{ 'Login.BackButton' | translate }}</button>
      <p class="LoginFormTitle">{{ 'EnterToken' | translate }}</p>
  
      <div class="MFAImage">
        <svg class="MFAImageSVG" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid"><path d="M256 127.998C256 198.696 198.694 256 127.997 256 57.304 256 0 198.696 0 127.998 0 57.305 57.304 0 127.997 0 198.694 0 256 57.305 256 127.998z" fill="#EC1C24"/><path d="M117.024 100.89l30.691 30.68c4.43 4.436 11.623 4.436 16.064 0 4.431-4.435 4.441-11.622 0-16.058L133.086 84.82C111.125 62.854 75.631 62.5 53.204 83.704a9.536 9.536 0 0 0-.605.548c-.098.098-.178.202-.275.29-.1.096-.202.182-.297.278-.194.193-.371.396-.54.597-21.215 22.437-20.85 57.932 1.113 79.897L83.292 196c4.44 4.433 11.623 4.433 16.062 0 4.442-4.437 4.442-11.633.011-16.06l-30.693-30.691c-13.398-13.393-13.488-35.129-.278-48.637 13.506-13.21 35.23-13.114 48.63.279zm39.612-40.873c-4.435 4.437-4.435 11.623.012 16.059l30.681 30.693c13.39 13.392 13.477 35.125.268 48.636-13.51 13.2-35.227 13.112-48.623-.282l-30.692-30.689c-4.438-4.437-11.633-4.437-16.066 0-4.443 4.433-4.443 11.642 0 16.065l30.682 30.694c21.968 21.965 57.458 22.322 79.889 1.116.208-.184.404-.355.61-.549.094-.095.182-.192.273-.29.1-.095.197-.183.29-.289.197-.183.365-.384.54-.594 21.215-22.428 20.86-57.911-1.102-79.889l-30.692-30.682c-4.436-4.443-11.638-4.443-16.07.001z" fill="#FFF"/></svg>
      </div>
  
      <mat-form-field appearance="outline" style="width: 100%;">
        <input autocomplete="off" class="MFATokenTextBox" [disabled]="loading" matInput placeholder="{{ 'MFAToken' | translate }}" value="" [(ngModel)]="this.MFAToken" required>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 100%;">
        <input autocomplete="off" class="MFATokenTextBox" [disabled]="loading" matInput placeholder="{{ 'PIN' | translate }}" value="" [(ngModel)]="this.parent.AppPIN" required>
      </mat-form-field>
  
          <button (click)="GetMFAResultCompanyDelete();" [disabled]="loadingMFA" mat-raised-button color="warn" class="tokenButton" matTooltip="{{ 'DeleteDataButtonDesc' | translate }}" matTooltipClass='neutral-tool-tip'>
            <i class="material-icons ButtonCenterImage">check</i>
            <span>{{ 'DeleteWholeCompany' | translate }}</span>
          </button>
        <mat-progress-bar mode="indeterminate" *ngIf="loadingMFA" class="loginIntermediateProgressBar"></mat-progress-bar>
    </div>

    <div class="overlay" *ngIf="ShowANAFRedirectionNotification || ShowMFACompanyDelete || ShowDeletingMasterEntitiesErrorResultsDetails || ShowDeletingMasterEntitiesErrorResults || DeletingEntitiesMasterContainer || ShowMFA || ShowBulkDeleteMasterContainer || ShowNewCompanyRelationshipContainer || ShowDeleteSMTPEmailQuestion || ShowDeleteSMTPQuestion || showAddNewAddressPopUp || showAddNewAgentPopUp || ShowDeleteBankAccountQuestion || ShowDeleteAdministrationQuestion"></div>

    <div *ngIf="ShowNewCompanyRelationshipContainer" class="animated fadeInDown NewPartnerPopUp">
      <div class="PopUpCloseContainer" (click)="ShowNewCompanyRelationshipContainer = false;">
        <i class="material-icons">close</i>
      </div>
      <div class="PopUpTitleContainer">
       <p>{{ 'NewCompanyRelationship' | translate }}</p>
      </div>

      <div class="PopUpBody" style="padding-top: 10px;">
        <div class="fullWidthContainer">
          <div class="PopUpBodyOneThirddContainer">
            
           <div class="fullWidthContainer">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'MainCompany' | translate }}</mat-label>
              <mat-select name="Company" [compareWith]="compareFn" [(ngModel)]="Company" required>
                <mat-option [value]="Company">
                  {{Company.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
           </div>

            <div class="fullWidthContainer">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'SlaveCompany' | translate }}</mat-label>
                <mat-select name="SlaveCompany" [compareWith]="compareFn" [(ngModel)]="SlaveCompany" required>
                  <mat-option *ngFor="let c of Companies" [value]="c">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          </div>
          <div class="PopUpBodyOneThirddContainer" *ngIf="Company !== undefined && SlaveCompany !== undefined;">

           <div class="fullWidthContainer">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'MasterAdministration' | translate }}</mat-label>
              <mat-select name="MasterAdministration" [compareWith]="compareFn" [(ngModel)]="MasterAdministration" required>
                <mat-option *ngFor="let a of this.Company.Administrations" [value]="a">
                  {{a.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
           </div>

           <div class="fullWidthContainer">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'SlaveAdministration' | translate }}</mat-label>
              <mat-select name="SlaveAdministration" [compareWith]="compareFn" [(ngModel)]="SlaveAdministration" required>
                <mat-option *ngFor="let a of this.SlaveCompany.Administrations" [value]="a">
                  {{a.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
           </div>

          </div>

          <div class="PopUpBodyOneThirddContainer" *ngIf="SlaveAdministration !== undefined && MasterAdministration !== undefined;">

            <div class="fullWidthContainer">
             <mat-form-field appearance="outline">
               <mat-label>{{ 'MasterSeries' | translate }}</mat-label>
               <mat-select name="MasterSeries" [compareWith]="compareFn" [(ngModel)]="MasterSeries" required>
                 <mat-option *ngFor="let a of this.Company.AccountingSeries" [value]="a">
                   {{a.Series}} ({{a.GeneralDocTypeObject.Name}})
                 </mat-option>
               </mat-select>
             </mat-form-field>
            </div>
 
            <div class="fullWidthContainer">
             <mat-form-field appearance="outline">
               <mat-label>{{ 'SlaveSeries' | translate }}</mat-label>
               <mat-select name="SlaveSeries" [compareWith]="compareFn" [(ngModel)]="SlaveSeries" required>
                 <mat-option *ngFor="let a of this.SlaveCompany.AccountingSeries" [value]="a">
                   {{a.Series}} ({{a.GeneralDocTypeObject.Name}})
                 </mat-option>
               </mat-select>
             </mat-form-field>
            </div>
 
           </div>
        </div>
      </div>

      <div class="PopUpCommands">
        <button (click)="AddCompanyRelationShip();" [disabled]="this.parent.loading" *ngIf="SlaveAdministration !== undefined && MasterAdministration !== undefined && SlaveSeries !== undefined && MasterSeries !== undefined;" mat-raised-button color="primary" matTooltip="{{ 'AddRelationship' | translate }}" class="PopGeneralCommandButton">{{ 'AddRelationship' | translate }}</button>
        <button disabled *ngIf="SlaveAdministration === undefined || MasterAdministration === undefined || SlaveSeries === undefined || MasterSeries === undefined;" mat-raised-button color="primary" matTooltip="{{ 'AddRelationship' | translate }}" class="PopGeneralCommandButton">{{ 'AddRelationship' | translate }}</button>
      </div>
    </div>

    <div *ngIf="showAddNewAddressPopUp" class="animated fadeInDown NewPartnerPopUp">
        <div class="PopUpCloseContainer" (click)="showAddNewAddressPopUp = false;">
          <i class="material-icons">close</i>
        </div>
        <div class="PopUpTitleContainer">
         <p>{{ 'Configuration.AddAddress' | translate }}</p>
        </div>
  
        <div class="PopUpBody">
  
          <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>
  
          <form [formGroup]="newAddress">
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Address' | translate }}</p>
    
            <div class="PopUpBodySemiTextBox">
              <mat-form-field>
                <mat-label>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</mat-label>
                <mat-select [(ngModel)]="newAddressCountry" name="country" formControlName="Country" required>
                  <mat-option *ngFor="let c of parent.masterData.Countries" [value]="c">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.StateProvince' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="StateProvince" required>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="City" required>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="AddressLine" required>
            </mat-form-field>

            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'ZipCode' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="ZipCode">
            </mat-form-field>
        
          </form>
  
        </div>
  
        <div class="PopUpCommands">
          <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Partner" class="PopGeneralCommandButton" (click)="AddNewAddress();">{{ 'Configuration.AddAddress' | translate }}</button>
        </div>
      </div>

      <div *ngIf="showAddNewAgentPopUp" class="animated fadeInDown NewPartnerPopUp">
        <div class="PopUpCloseContainer" (click)="showAddNewAgentPopUp = false;">
          <i class="material-icons">close</i>
        </div>
        <div class="PopUpTitleContainer">
         <p>{{ 'Configuration.AddAgent' | translate }}</p>
        </div>
  
        <div class="PopUpBody">
  
          <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>
  
          <form [formGroup]="newAgent">
    
            <div class="PopUpBodySemiTextBox">
              <mat-form-field>
                <mat-label>{{ 'Configuration.AllocatedAddress' | translate }}</mat-label>
                <mat-select [compareWith]="compareFn" [(ngModel)]="newAgentAddress" name="address" formControlName="Address" required>
                  <mat-option *ngFor="let a of Company.Addresses" [value]="a">
                    {{a.Country.Name}} {{a.StateProvince}} {{a.City}} {{a.AddressLine}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field *ngIf="this.currentAgent?.ID > 0;">
                <mat-label>{{ 'Department' | translate }}</mat-label>
                <mat-select [compareWith]="compareFn" [(ngModel)]="currentAgent.Department" name="Department" formControlName="Department" required>
                  <mat-option *ngFor="let d of this.AccountingMasterData.Departments" [value]="d">
                    {{d.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="PopUpBodySemiTextBox FileChosingContainer" *ngIf="this.currentAgent != null;">
              <form [formGroup]="newBlogForm" (ngSubmit)="AddAgentSignature(newBlogForm.value)">
                <div style="margin-bottom: 15px;">
                    <input mat-raised-button type="file" formControlName="UploadedFile" (change)="onSelectFile($event)" >
                </div>
                <button type="submit" mat-raised-button>{{ 'UploadSignature' | translate }}</button>
              </form>
            </div>

            <div class="PopUpBodySemiTextBox FileChosingContainer" *ngIf="this.currentAgent?.Signature != null;">
              <p class="signatureTitle">{{ 'Signature' | translate }}:</p>
              <img [src]="this.parent.BackendServiceUrl + this.currentAgent?.Signature" class="signatureImage" />
            </div>
    
            <div class="fullWidthContainer">
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Configuration.FullName' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="Name" required>
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Login.Phone' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="Phone">
              </mat-form-field>
      
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Login.Email' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="Email">
              </mat-form-field>
  
              <mat-form-field class="example-full-width PopUpBodySemiTextBox">
                <mat-label>{{ 'Configuration.Function' | translate }}</mat-label>
                <input matInput placeholder="" value="" autocomplete="off" formControlName="Function" required>
              </mat-form-field>
            </div>
        
          </form>
  
        </div>
  
        <div class="PopUpCommands">
          <button (click)="this.AddUpdateAgent();" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Partner" class="PopGeneralCommandButton">{{ 'Configuration.AddAgent' | translate }}</button>
        </div>
      </div>

      <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteBankAccountQuestion">
        <div class="InfoQuestionClose">
          <i class="material-icons" (click)="ShowDeleteBankAccountQuestion = false;">close</i>
        </div>
        <div class="InfoQuestionTitle">
          {{ 'Configuration.DeleteBankAccountQuestion' | translate }}
        </div>
        <div class="InfoQuestionBody">
          {{ 'Configuration.DeleteBankAccountQuestionDescription' | translate }}
        </div>

        <div class="InfoQuestionCommands">
          <button mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteBankAccountQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
          <button mat-raised-button color="warn" class="InfoQuestionButton" (click)="DeleteCompanyBankAccount();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
        </div>
      </div>

      <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteAdministrationQuestion">
        <div class="InfoQuestionClose">
          <i class="material-icons" (click)="ShowDeleteAdministrationQuestion = false;">close</i>
        </div>
        <div class="InfoQuestionTitle">
          {{ 'Configuration.DeleteQuestion' | translate }}
        </div>
        <div class="InfoQuestionBody">
          {{ 'Configuration.DeleteQuestionDescription' | translate }}
        </div>

        <div class="InfoQuestionCommands">
          <button mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteAdministrationQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
          <button mat-raised-button color="warn" class="InfoQuestionButton" (click)="DeleteCompanyAdministration();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
        </div>
      </div>

    <mat-tab-group style="margin-top: 4px;" (selectedTabChange)="tabClick($event)">
        <mat-tab label="{{ 'Configuration.CompanyData' | translate }}"> 

              <div class="fullWidthContainer" *ngIf="loading" style="margin-top: 5%;">
                <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
              </div>

            <div class="MainTabBody" *ngIf="!loading">
                
                <mat-form-field class="example-full-width halfWidth">
                    <mat-label>{{ 'Partners.VAT' | translate }}</mat-label>
                    <input matInput [(ngModel)]="this.Company.VATNumber">
                  </mat-form-field>
        
                  <mat-form-field class="example-full-width halfWidth">
                    <mat-label>{{ 'Partners.Name' | translate }}</mat-label>
                    <input matInput [(ngModel)]="this.Company.Name">
                  </mat-form-field>

                  <mat-form-field class="example-full-width halfWidth">
                    <mat-label>{{ 'Partners.COCRegNumber' | translate }}</mat-label>
                    <input matInput [(ngModel)]="this.Company.COCRegisterNr">
                  </mat-form-field>

                  <mat-form-field class="example-full-width halfWidth">
                    <mat-label>{{ 'Partners.Alias' | translate }}</mat-label>
                    <input matInput [(ngModel)]="this.Company.Alias">
                  </mat-form-field>

                  <mat-form-field class="example-full-width halfWidth" appearance="outline">
                    <mat-label>{{ 'AccountSettingsPage.UserCompanyRoles' | translate }}</mat-label>
                    <input matInput disabled [(ngModel)]="this.parent.Company.MainRole.Meaning">
                  </mat-form-field>

                  <div class="fullWidthContainer" style="margin-bottom: 2%;">

                    <div class="halfWidth">
                      <button mat-raised-button color="primary" (click)="UpdateCompanyData();"><i class="material-icons">save_alt</i> {{ 'Configuration.UpdateCompany' | translate }}</button>
                    </div>
                  </div>

                  <div class="fullWidthContainer">
                    <p class="ExpandTabTitle">{{ 'UXDetails' | translate }}:</p>
                  </div>

                  <div class="fullWidthContainer" style="padding-left: 3px; padding-right: 3px;" *ngIf="Company.UXDetails?.ShowPartnerFinancialData != null;">
                      <mat-slide-toggle (change)="AddUpdateCompanyUXDetails($event)" [(ngModel)]="Company.UXDetails.ShowPartnerFinancialData">{{ 'ShowPartnerFinancialData' | translate }}</mat-slide-toggle>
                  </div>

                  <div class="fullWidthContainer">
                    <p class="ExpandTabTitle">{{ 'Configuration.CompanyAddresses' | translate }}:</p>
                  </div>

                  <div class="fullWidthContainer" style="padding-left: 3px; padding-right: 3px;">
                    <mat-accordion>

                        <mat-expansion-panel disabled>
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                {{ 'Country' | translate }}
                              </mat-panel-title>
                              <mat-panel-description>
                                {{ 'Partners.PartnerWindow.StateProvince' | translate }}
                              </mat-panel-description>
                              <mat-panel-description>
                                {{ 'Partners.PartnerWindow.City' | translate }}
                              </mat-panel-description>
                            </mat-expansion-panel-header>
                          </mat-expansion-panel>
                
                        <mat-expansion-panel *ngFor="let a of this.Company.Addresses; index as i">
                          <mat-expansion-panel-header class="ExpandHeadder">
                            <mat-panel-title>
                              {{a.Country.Name}}
                            </mat-panel-title>
                            <mat-panel-description>
                              {{a.StateProvince}}
                            </mat-panel-description>
                            <mat-panel-description>
                                {{a.City}}
                              </mat-panel-description>
                          </mat-expansion-panel-header>
                
                          <div *ngIf="!loading" style="margin-top: 20px;">
                
                            <div class="fullWidthContainer">
                                <mat-form-field appearance="outline">
                                    <mat-label>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</mat-label>
                                    <mat-select name="country" [compareWith]="compareFn" [(ngModel)]="a.Country" required>
                                      <mat-option *ngFor="let c of parent.masterData.Countries" [value]="c">
                                        {{c.Name}}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                            </div>
        
                            <div class="halfWidth">
                                <mat-form-field class="example-full-width halfWidth" appearance="outline">
                                    <mat-label>{{ 'Partners.PartnerWindow.StateProvince' | translate }}</mat-label>
                                    <input matInput [(ngModel)]="a.StateProvince">
                                  </mat-form-field>
            
                                  <mat-form-field class="example-full-width halfWidth" appearance="outline">
                                    <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}</mat-label>
                                    <input matInput [(ngModel)]="a.City">
                                  </mat-form-field>
                            </div>
        
                              <mat-form-field class="example-full-width halfWidth" appearance="outline">
                                <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}</mat-label>
                                <input matInput [(ngModel)]="a.AddressLine">
                              </mat-form-field>

                              <div class="fullWidthContainer">
                                <mat-form-field class="example-full-width" appearance="outline">
                                    <mat-label>{{ 'ZipCode' | translate }}</mat-label>
                                    <input matInput [(ngModel)]="a.ZipCode">
                                  </mat-form-field>
                              </div>
    
                              <button mat-raised-button color="primary" (click)="UpdateAddress(a);"><i class="material-icons">save_alt</i> {{ 'Configuration.UpdateAddress' | translate }}</button>
                              <button style="margin-left: 10px;" mat-button color="warn" (click)="DeleteCompanyAddress(a.ID);"><i class="material-icons">close</i> {{ 'Configuration.DeleteAddress' | translate }}</button>
                            </div>
                
                        </mat-expansion-panel>
                      </mat-accordion>
                  </div>

                  <div class="halfWidth" style="margin-top: 2%;padding-left: 3px;">
                    <button mat-raised-button color="primary" (click)="initializeAddAddressForm();showAddNewAddressPopUp = true;">
                        <i class="material-icons">add_location_alt</i>
                    </button>
                  </div>
                  
                  <div class="fullWidthContainer">
                    <p class="ExpandTabTitle">{{ 'Configuration.CompanyAgents' | translate }}:</p>
                  </div>

                  <div class="fullWidthContainer" style="margin-top: 2%;padding-left: 3px;">
                    <button mat-raised-button color="primary" (click)="currentAgent = null; initializeAddAgentForm(); showAddNewAgentPopUp = true;">
                        <i class="material-icons">group_add</i>
                    </button>
                  </div>

                  <div class="fullWidthContainer">
                    <div class="halfWidth">
                      <mat-selection-list [multiple]="false">
                        <mat-list-option *ngFor="let a of this.Company.Agents">
                          <i class="material-icons agentSettings" (click)="this.currentAgent = a;initializeAddAgentForm(); showAddNewAgentPopUp = true;">edit</i>
                          <i class="material-icons agentDelete" (click)="DeleteAgent(a.ID);">close</i>
                          {{a.Name}}
                        </mat-list-option>
                      </mat-selection-list>
                    </div>
                  </div>

                  <div class="fullWidthContainer">
                    <p class="ExpandTabTitle">{{ 'EmailServers' | translate }}:</p>

                    <div class="fullWidthContainer" *ngIf="NewSMTP == null;" style="margin-bottom: 20px;">
                      <button mat-flat-button color="accent" (click)="InitializeNewSMTP();">{{'AddNew' | translate}}</button>
                    </div>

                    <div style="margin-top: 20px;" *ngIf="NewSMTP != null;">
                      <div class="halfWidth">
                        <mat-form-field class="example-full-width halfWidth" appearance="outline">
                          <mat-label>{{ 'SMTP' | translate }}</mat-label>
                          <input matInput [(ngModel)]="NewSMTP.SMTPServer">
                        </mat-form-field>

                        <mat-form-field class="example-full-width halfWidth" appearance="outline">
                          <mat-label>{{ 'Port' | translate }}</mat-label>
                          <input matInput [(ngModel)]="NewSMTP.Port">
                        </mat-form-field>
                      </div>

                      <div class="halfWidth">
                        <button (click)="AddUpdateSMTPServerConfig(NewSMTP);" class="ExpansionSaveListButton" mat-flat-button color="primary">{{'Configuration.SaveChanges' | translate}}</button>
                        <button (click)="NewSMTP = null;" class="ExpansionSaveListButton" mat-flat-button color="warn" style="margin-right: 10px;">{{'Delete' | translate}}</button>
                      </div>
                    </div>
                  </div>

                  <div class="fullWidthContainer" style="padding-left: 3px; padding-right: 3px;margin-bottom: 5%;">
                    <mat-accordion>

                        <mat-expansion-panel disabled>
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                {{ 'SMTP' | translate }}
                              </mat-panel-title>
                              <mat-panel-description>
                                
                              </mat-panel-description>
                              <mat-panel-description>
                                {{ 'Port' | translate }}
                              </mat-panel-description>
                            </mat-expansion-panel-header>
                          </mat-expansion-panel>
                
                        <mat-expansion-panel *ngFor="let s of this.SMTPConfigs; index as i" (opened)="GetCompanySMTPEmails(s.ID); CurrenctSMTP = s;">
                          <mat-expansion-panel-header class="ExpandHeadder">
                            <mat-panel-title>
                              {{s.SMTPServer}}
                            </mat-panel-title>
                            <mat-panel-description>
                              
                            </mat-panel-description>
                            <mat-panel-description>
                              {{s.Port}}
                              </mat-panel-description>
                          </mat-expansion-panel-header>
                
                          <div style="margin-top: 20px;">
                            <div class="halfWidth">
                              <mat-form-field class="example-full-width halfWidth" appearance="outline">
                                <mat-label>{{ 'SMTP' | translate }}</mat-label>
                                <input matInput [(ngModel)]="s.SMTPServer">
                              </mat-form-field>

                              <mat-form-field class="example-full-width halfWidth" appearance="outline">
                                <mat-label>{{ 'Port' | translate }}</mat-label>
                                <input matInput [(ngModel)]="s.Port">
                              </mat-form-field>
                            </div>

                            <div class="halfWidth">
                              <button (click)="AddUpdateSMTPServerConfig(s);" class="ExpansionSaveListButton" mat-flat-button color="primary">{{'Configuration.SaveChanges' | translate}}</button>
                              <button (click)="ShowDeleteSMTPQuestion = true;" class="ExpansionSaveListButton" mat-flat-button color="warn" style="margin-right: 10px;">{{'Delete' | translate}}</button>
                            </div>
                          </div>

                          <div class="fullWidthContainer">
                            <p class="ExpandTabTitle">{{ 'EmailAddresses' | translate }}:</p>
                          </div>

                          <div *ngIf="!loadingUser" style="margin-top: 2%;">
                            <div class="fullWidthContainer" *ngFor="let e of this.SMTPEmails; index as j">
                             <div class="halfWidth">

                              <mat-form-field class="example-full-width halfWidth" appearance="outline">
                                <mat-label>{{ 'Email' | translate }}</mat-label>
                                <input matInput [(ngModel)]="e.Email">
                              </mat-form-field>

                              <mat-form-field class="example-full-width halfWidth" appearance="outline">
                                <mat-label>{{ 'Password' | translate }}</mat-label>
                                <input matInput [(ngModel)]="e.Password" [type]="e.HidePassword ? 'password' : 'text'">
                                <mat-icon style="cursor: pointer;" matSuffix (click)="e.HidePassword = !e.HidePassword">{{e.HidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                              </mat-form-field>

                             </div>

                             <div class="halfWidth" style="height:60.53px;padding-top:8px;">
                              <mat-slide-toggle class="halfWidth" [(ngModel)]="e.IsDefault">{{'DefaultAddress' | translate}}</mat-slide-toggle>
                              <button (click)="AddUpdateCompanySMTPEmail(e);" class="ExpansionSaveListButton" mat-stroked-button color="primary">{{'Configuration.SaveChanges' | translate}}</button>
                              <button (click)="CurrenctSMTPEmail = e; ShowDeleteSMTPEmailQuestion = true;" class="ExpansionSaveListButton" mat-stroked-button color="warn" style="margin-right: 10px;">{{'Delete' | translate}}</button>
                            </div>

                            </div>

                            <div class="fullWidthContainer">
                              <button *ngIf="NewSMTPEmail == null;" mat-flat-button color="accent" (click)="InitializeNewSMTPEmail();">{{'AddNew' | translate}}</button>
                            </div>

                            <div class="fullWidthContainer" *ngIf="NewSMTPEmail != null;">
                              <div class="halfWidth">
 
                               <mat-form-field class="example-full-width halfWidth" appearance="outline">
                                 <mat-label>{{ 'Email' | translate }}</mat-label>
                                 <input matInput [(ngModel)]="NewSMTPEmail.Email">
                               </mat-form-field>
 
                               <mat-form-field class="example-full-width halfWidth" appearance="outline">
                                 <mat-label>{{ 'Password' | translate }}</mat-label>
                                 <input matInput [(ngModel)]="NewSMTPEmail.Password" [type]="NewSMTPEmail.HidePassword ? 'password' : 'text'">
                                 <mat-icon style="cursor: pointer;" matSuffix (click)="NewSMTPEmail.HidePassword = !NewSMTPEmail.HidePassword">{{NewSMTPEmail.HidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                               </mat-form-field>
 
                              </div>
 
                              <div class="halfWidth" style="height:60.53px;padding-top:8px;">
                               <mat-slide-toggle class="halfWidth" [(ngModel)]="NewSMTPEmail.IsDefault">{{'DefaultAddress' | translate}}</mat-slide-toggle>
                               <button (click)="AddUpdateCompanySMTPEmail(NewSMTPEmail);" class="ExpansionSaveListButton" mat-stroked-button color="primary">{{'Configuration.SaveChanges' | translate}}</button>
                               <button (click)="NewSMTPEmail = null;" class="ExpansionSaveListButton" mat-stroked-button color="warn" style="margin-right: 10px;">{{'Delete' | translate}}</button>
                             </div>
 
                             </div>

                          </div>

                           <div class="fullWidthContainer" *ngIf="loadingUser">
                            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
                          </div>

                        </mat-expansion-panel>
                      </mat-accordion>
                  </div>

                  <div class="fullWidthContainer">
                    <p class="ExpandTabTitle">{{ 'CompanyLogo' | translate }}</p>
                  </div>

                  <div class="fullWidthContainer" *ngIf="this.Company?.LogoPath?.length > 0;">
                    <img [src]="this.parent.BackendServiceUrl + this.Company?.LogoPath" class="signatureImage" />
                  </div>

                  <div class="fullWidthContainer">
                    <form [formGroup]="newCompanyLogo" (ngSubmit)="AddUpdateCompanyLogo()">
                      <div style="margin-bottom: 15px;">
                          <input mat-raised-button type="file" formControlName="UploadedFile" (change)="onSelectFile($event)" >
                      </div>
                      <button type="submit" mat-raised-button>{{ 'UploadLogo' | translate }}</button>
                    </form>
                  </div>
            </div>
        </mat-tab>
        <mat-tab label="{{ 'BankAccounts' | translate }}"> 
          <div class="fullWidthContainer" *ngIf="loading" style="margin-top: 5%;">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>

          <div class="MainTabBody">
            <p class="MainTabBodyTitle">{{'AddNewBank' |  translate}}</p>

            <div class="example-full-width">
              <mat-form-field class="example-full-width" appearance="outline" style="width: 20%;">
                <mat-label>{{ 'BankName' | translate }}</mat-label>
                <input matInput [(ngModel)]="NewBank.Name">
              </mat-form-field>
            </div>
           <div class="example-full-width">
              <mat-form-field class="example-full-width" appearance="outline" style="width: 20%;">
              <mat-label>{{ 'Swift' | translate }}</mat-label>
              <input matInput [(ngModel)]="NewBank.Swift">
              </mat-form-field>
           </div>
            <button mat-raised-button color="primary" (click)="AddBank(NewBank);"><i class="material-icons">save_alt</i> {{ 'AddNewBank' | translate }}</button>
          </div>

          <div class="MainTabBody" *ngIf="!loading">
            <div class="BankAccountRow" *ngFor="let b of this.Company.Banks; index as i">
             <div *ngFor="let a of b.BankAccounts; index as j" class="fullWidthContainer">
              <div class="thirdContainer" style="width: auto;">
                <i class="material-icons ReceptionProductEdit" (click)="AskDeleteBankAccountQuestion(a);">close</i>
              </div>

              <div class="thirdContainer">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Bank' | translate }}</mat-label>
                  <mat-select name="bank" [compareWith]="compareFnID" [(ngModel)]="a.BankID" required>
                    <mat-option *ngFor="let b of parent.masterData.Banks" [value]="b">
                      {{b.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="thirdContainer">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Currency' | translate }}</mat-label>
                  <mat-select name="currency" [compareWith]="compareFn" [(ngModel)]="a.Currency" required>
                    <mat-option *ngFor="let c of parent.masterData.Currencies" [value]="c">
                      {{c.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="thirdContainer" style="width: 25%;">
                <mat-form-field class="example-full-width fullWidthContainer" appearance="outline">
                  <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
                  <input matInput [(ngModel)]="a.AccountNumber">
                </mat-form-field>
              </div>

              <div class="thirdContainer" style="width: 15%;height: 61.8px;padding-top: 8px;">
                <mat-slide-toggle [(ngModel)]="a.IsActive">{{'IsActive' | translate}}</mat-slide-toggle>
              </div>

              <div class="thirdContainer" style="width: 15%;height: 61.8px;padding-top: 8px;">
                <mat-form-field appearance="outline" class="example-full-width fullWidthContainer" style="width: 30%; text-align: center;">
                  <mat-label>{{'OrderRank' | translate}}</mat-label>
                  <input matInput type="number" [(ngModel)]="a.OrderRank" min="0" max="100" step="1">
                </mat-form-field>
              </div>
             </div>
            </div>

            <div class="thirdContainer">
              <button mat-mini-fab color="primary" aria-label="Example icon button with a delete icon" (click)="initializeNewBankAccount();">
                <mat-icon>add</mat-icon>
              </button>
            </div>

            <div class="fullWidthContainer" *ngIf="newBankAccount != null;">

              <div class="thirdContainer" style="width: auto;">
                <i class="material-icons ReceptionProductEdit" (click)="newBankAccount = null;">close</i>
              </div>

              <div class="thirdContainer">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Bank' | translate }}</mat-label>
                  <mat-select name="bank" [compareWith]="compareFnID" [(ngModel)]="newBankAccount.Bank" required>
                    <mat-option *ngFor="let b of parent.masterData.Banks" [value]="b">
                      {{b.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="thirdContainer">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Currency' | translate }}</mat-label>
                  <mat-select name="currency" [compareWith]="compareFn" [(ngModel)]="newBankAccount.Currency" required>
                    <mat-option *ngFor="let c of parent.masterData.Currencies" [value]="c">
                      {{c.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="thirdContainer" style="width: 32%;">
                <mat-form-field class="example-full-width fullWidthContainer" appearance="outline">
                  <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
                  <input matInput [(ngModel)]="newBankAccount.AccountNumber" required>
                </mat-form-field>
              </div>

              <div class="thirdContainer">
                <button mat-mini-fab color="primary" aria-label="Example icon button with a delete icon" (click)="AddCompanyBankAccount();">
                  <i class="material-icons">save_alt</i>
                </button>
              </div>
            </div>

            <div class="fullWidthContainer">
              <button mat-raised-button color="primary" (click)="UpdateCompanyBankAccountsBulk();"><i class="material-icons">save_alt</i> {{ 'Configuration.SaveChanges' | translate }}</button>
            </div>

          </div>

        </mat-tab>
        <mat-tab label="{{ 'DocumentSeries' | translate }}"> 
          <div class="fullWidthContainer" *ngIf="loading" style="margin-top: 5%;">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>

          <div class="MainTabBody" *ngIf="!loading">

            <div class="SeriesRow" *ngFor="let s of this.Company.AccountingSeries; index as i">

              <div class="fullWidthContainer">
                <div class="thirdContainer" style="width: auto;padding-top: 10px;">
                  <mat-slide-toggle [(ngModel)]="s.IsActive" (change)="UpdateAccountingSeriesActiveFlag(s);">{{ 'IsActive' | translate }}</mat-slide-toggle>
                </div>
  
                <div class="thirdContainer">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'DocumentType' | translate }}</mat-label>
                    <mat-select name="bank" [compareWith]="compareFn" [(ngModel)]="s.GeneralDocTypeObject" disabled="disabled" required>
                      <mat-option *ngFor="let doc of AccountingMasterData.GeneralDocTypes" [value]="doc">
                        {{doc.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
  
                <div class="thirdContainer" style="width: 10%;">
                  <mat-form-field class="example-full-width fullWidthContainer" appearance="outline">
                    <mat-label>{{ 'Series' | translate }}</mat-label>
                    <input matInput [(ngModel)]="s.Series">
                  </mat-form-field>
                </div>

                <div class="thirdContainer" style="width: 10%;">
                  <mat-form-field class="example-full-width fullWidthContainer" appearance="outline">
                    <mat-label>{{ 'HighestValue' | translate }}</mat-label>
                    <input matInput [(ngModel)]="s.HighestValue" disabled="disabled">
                  </mat-form-field>
                </div>
                
                <div class="thirdContainer" style="width: 10%;">
                  <mat-form-field class="example-full-width fullWidthContainer" appearance="outline">
                    <mat-label>{{ 'StartIndex' | translate }}</mat-label>
                    <input matInput [(ngModel)]="s.StartIndex">
                  </mat-form-field>
                </div>
  
                <div class="thirdContainer">
                  <button *ngIf="s.DeletePossibility == true;" mat-mini-fab color="warn" (click)="DeleteAccountingSeries(s.ID);">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>

              </div>
              <div class="fullWidthContainer">
                  <form [formGroup]="newBlogForm" (ngSubmit)="AddSeriesLogo(s.ID)" style="width: auto;float: left;">
                    <div style="margin-bottom: 10px;">
                        <input mat-raised-button type="file" formControlName="UploadedFile" (change)="onSelectFile($event)" >
                    </div>
                  
                    <button type="submit" mat-raised-button>{{ 'UploadLogo' | translate }}</button>
                  </form>

                  <div class="thirdContainer" *ngIf="s.LogoPath != null;">
                    <img [src]="this.parent.BackendServiceUrl + s.LogoPath" class="signatureImage" />
                  </div>

                  <div class="fullWidthContainer" style="margin-top: 20px;">
                   <div class="thirdContainer">
                    <mat-form-field class="example-full-width fullWidthContainer" appearance="outline">
                      <mat-label>{{ 'ColorHash' | translate }}</mat-label>
                      <input matInput [(ngModel)]="s.ColorHash">
                    </mat-form-field>
                   </div>

                   <div class="ColorHashChoiceContainer">
                      <div class="ColorHashChoice" style="background: #254a91;" (click)="s.ColorHash = '#254a91'">
                        <i class="material-icons ColorHashChoiceIcon" *ngIf="s.ColorHash == '#254a91'">check</i>
                      </div>

                      <div class="ColorHashChoice" style="background: #00aeef;" (click)="s.ColorHash = '#00aeef'">
                        <i class="material-icons ColorHashChoiceIcon" *ngIf="s.ColorHash == '#00aeef'">check</i>
                      </div>

                      <div class="ColorHashChoice" style="background: #2CA70F;" (click)="s.ColorHash = '#2CA70F'">
                        <i class="material-icons ColorHashChoiceIcon" *ngIf="s.ColorHash == '#2CA70F'">check</i>
                      </div>

                      <div class="ColorHashChoice" style="background: #f60;" (click)="s.ColorHash = '#f60'">
                        <i class="material-icons ColorHashChoiceIcon" *ngIf="s.ColorHash == '#f60'">check</i>
                      </div>

                      <div class="ColorHashChoice" style="background: #0082e6;" (click)="s.ColorHash = '#0082e6'">
                        <i class="material-icons ColorHashChoiceIcon" *ngIf="s.ColorHash == '#0082e6'">check</i>
                      </div>

                      <div class="ColorHashChoice" style="background: #5b2281;" (click)="s.ColorHash = '#5b2281'">
                        <i class="material-icons ColorHashChoiceIcon" *ngIf="s.ColorHash == '#5b2281'">check</i>
                      </div>
                  </div>
                  </div>

                  <div class="fullWidthContainer" style="margin-bottom: 20px;">
                    <mat-slide-toggle [(ngModel)]="s.GenerateQRCodeOnDocuments">{{'GenerateQRCodeOnDocuments' | translate}}</mat-slide-toggle>
                  </div>

                  <div class="fullWidthContainer" style="margin-bottom: 20px;">
                    <button mat-raised-button color="primary" (click)="UpdateAccountingSeries(s);"><i class="material-icons">save_alt</i> {{ 'Configuration.SaveChanges' | translate }}</button>
                  </div>
              </div>
            </div>

            <button mat-mini-fab color="primary" aria-label="Example icon button with a delete icon" (click)="initializeNewSeries();" style="margin-right: 10px;">
              <mat-icon>add</mat-icon>
            </button>
           
            <div class="fullWidthContainer" *ngIf="newSeries != null;">
              <div class="thirdContainer" style="width: auto;padding-top: 10px;">
                <mat-slide-toggle [(ngModel)]="newSeries.IsActive">{{ 'IsActive' | translate }}</mat-slide-toggle>
              </div>

              <div class="thirdContainer">
                <mat-form-field appearance="outline">
                  <mat-label>Document Type</mat-label>
                  <mat-select name="bank" [compareWith]="compareFn" [(ngModel)]="newSeries.GeneralDocTypeObject" required>
                    <mat-option *ngFor="let doc of AccountingMasterData.GeneralDocTypes" [value]="doc">
                      {{doc.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="thirdContainer" style="width: 10%;">
                <mat-form-field class="example-full-width fullWidthContainer" appearance="outline">
                  <mat-label>Series</mat-label>
                  <input matInput [(ngModel)]="newSeries.Series">
                </mat-form-field>
              </div>

              <div class="thirdContainer" style="width: 10%;">
                <mat-form-field class="example-full-width fullWidthContainer" appearance="outline">
                  <mat-label>Highest Value</mat-label>
                  <input matInput [(ngModel)]="newSeries.HighestValue" disabled="disabled">
                </mat-form-field>
              </div>

              <div class="thirdContainer">
                <button mat-mini-fab color="primary" aria-label="Example icon button with a delete icon" (click)="AddNewCompanySeries();">
                  <mat-icon>save_alt</mat-icon>
                </button>

                <button mat-mini-fab color="warn" style="margin-left: 10px;" (click)="newSeries = null;">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>

          </div>
        </mat-tab>
        <mat-tab label="{{ 'Administrations' | translate }}"> 
          <div class="fullWidthContainer" *ngIf="loading" style="margin-top: 5%;">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>

          <div class="MainTabBody" *ngIf="!loading">

            <div *ngFor="let a of this.Company.Administrations; index as j" class="fullWidthContainer">

              <div class="thirdContainer" style="width: auto;">
                <i class="material-icons ReceptionProductEdit" (click)="AskDeleteAdministrationQuestion(a);">close</i>
              </div>

              <div class="thirdContainer">
                <mat-form-field class="example-full-width fullWidthContainer" appearance="outline">
                  <mat-label>{{ 'AdministrationName' | translate }}</mat-label>
                  <input matInput [(ngModel)]="a.Name" disabled="disabled">
                </mat-form-field>
              </div>

             </div>

             <div class="thirdContainer">
              <button mat-mini-fab color="primary" aria-label="Example icon button with a delete icon" (click)="initializeNewAdministration();">
                <mat-icon>add</mat-icon>
              </button>
            </div>

            <div class="fullWidthContainer" *ngIf="newAdministration != null;">

              <div class="thirdContainer" style="width: auto;">
                <i class="material-icons ReceptionProductEdit" (click)="newAdministration = null;">close</i>
              </div>

              <div class="thirdContainer" style="width: 32%;">
                <mat-form-field class="example-full-width fullWidthContainer" appearance="outline">
                  <mat-label>{{ 'AdministrationName' | translate }}</mat-label>
                  <input matInput [(ngModel)]="newAdministration.Name" required>
                </mat-form-field>
              </div>

              <div class="thirdContainer">
                <button mat-mini-fab color="primary" aria-label="Example icon button with a delete icon" (click)="AddCompanyAdministration();">
                  <i class="material-icons">save_alt</i>
                </button>
              </div>
            </div>

          </div>

        </mat-tab>
        <mat-tab label="{{ 'Dashboard.Menu.Partners' | translate }}"> 
          <div class="fullWidthContainer" *ngIf="loading" style="margin-top: 5%;">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>

          <div class="MainTabBody" *ngIf="!loading">

            <div class="thirdContainer">
              <button mat-button color="primary" aria-label="Example icon button with a delete icon" (click)="OpenNewCompanyRelationship();">
                {{'NewCompanyRelationship' | translate}}
                <mat-icon style="margin-top:-2px;">add</mat-icon>
              </button>
            </div>

            <div *ngFor="let r of this.Company.Relationships; index as i" class="fullWidthContainer RelationShipContainer" style="margin-bottom: 25px;">
              
              <div class="fullWidthContainer" style="margin-bottom: 20px;">
                <mat-slide-toggle [(ngModel)]="r.Active">{{'IsActive' | translate}}</mat-slide-toggle>
              </div>

              <div class="fullWidthContainer" style="margin-bottom: 20px;">
                <mat-slide-toggle [(ngModel)]="r.Automatic">{{'AutomaticInvoicesReceptionsInsert' | translate}}</mat-slide-toggle>
              </div>
              
              <div class="fullWidthContainer">
                 <div class="fullWidthContainer">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'MainCompany' | translate }} | Profit: {{r.MasterProfitMargin}}%</mat-label>
                    <mat-select [disabled]="true" name="Company" [compareWith]="compareFn" [(ngModel)]="Company" required>
                      <mat-option [value]="Company">
                        {{Company.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'SlaveCompany' | translate }} | Profit: {{100 - r.MasterProfitMargin}}%</mat-label>
                    <mat-select [disabled]="true" name="r.SlaveCompanyID" [compareWith]="compareFnID" [(ngModel)]="r.SlaveCompanyID" required>
                      <mat-option *ngFor="let c of Companies" [value]="c">
                        {{c.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                 </div>

                <div class="fullWidthContainer">
                 <div class="PopUpBodyOneThirddContainer">
                  <button mat-button color="primary" (click)="r.MasterProfitMargin = r.MasterProfitMargin + 1;">+1 Profit</button>
                  <button mat-button color="primary" (click)="r.MasterProfitMargin = r.MasterProfitMargin - 1;">-1 Profit</button>

                  <button mat-raised-button color="primary" (click)="UpdateCompanyRelationshipProfitMargin(r);">{{'SaveButton' | translate}}</button>
                 </div>
                </div>

              </div>
            </div>

          </div>

        </mat-tab>
        <mat-tab label="{{ 'AutoPrintSettings' | translate }}"> 
          <div class="fullWidthContainer" *ngIf="loading" style="margin-top: 5%;">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>

          <div class="MainTabBody" *ngIf="!loading">

            <div class="fullWidthContainer">
              <mat-form-field appearance="outline" style="width: 45%;">
                <mat-label>{{ 'AutoPrintSettings' | translate }}</mat-label>
                <mat-select name="AutoPrintSettings" [compareWith]="compareFn" [(ngModel)]="this.PrinterSettings" required>
                  <mat-option *ngFor="let p of this.Company.PrinterSettings" [value]="p" (click)="SelectPrinterSettings(p);">
                    {{p.PrinterName}} <span *ngIf="p.UserID?.length > 0">({{'PersonalSettings' | translate}})</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <p *ngIf="this.PrinterSettings?.UserID?.length > 0">
              {{'PersonalSettings' | translate}}
            </p>

            <div class="fullWidthContainer" *ngIf="this.PrinterSettingsUserName?.length > 0;">
              <mat-form-field class="example-full-width halfWidth" appearance="outline">
                <mat-label>{{ 'UsersSettings' | translate }}</mat-label>
                <input disabled matInput [(ngModel)]="this.PrinterSettingsUserName">
              </mat-form-field>
            </div>

            <div class="fullWidthContainer">
              <mat-form-field class="example-full-width halfWidth" appearance="outline">
                <mat-label>{{ 'Partners.Name' | translate }}</mat-label>
                <input disabled matInput [(ngModel)]="this.Company.Name">
              </mat-form-field>
            </div>
        
            <div class="fullWidthContainer">
              <mat-form-field class="example-full-width halfWidth" appearance="outline">
                <mat-label>{{ 'PrinterName' | translate }}</mat-label>
                <input matInput [(ngModel)]="this.PrinterSettings.PrinterName">
              </mat-form-field>
            </div>
  
            <div class="fullWidthContainer">
              <mat-form-field class="example-full-width halfWidth" appearance="outline">
                <mat-label>{{ 'APIAddress' | translate }}</mat-label>
                <input matInput [(ngModel)]="this.PrinterSettings.APIAddress">
              </mat-form-field>
            </div>

            <div class="fullWidthContainer">
              <mat-form-field class="example-full-width halfWidth" appearance="outline">
                <mat-label>{{ 'IPAddress' | translate }}</mat-label>
                <input matInput [(ngModel)]="this.PrinterSettings.IPAddress">
              </mat-form-field>
            </div>

            <div class="fullWidthContainer" style="padding-left: 0.5%;">
              <mat-slide-toggle [(ngModel)]="this.PrinterSettings.TwoSidedPrint">{{'TwoSidedPrint' | translate}}</mat-slide-toggle>
            </div>

            <div class="fullWidthContainer" style="margin-top: 20px;">
              <mat-form-field class="example-full-width halfWidth" appearance="outline" style="width: 100px;">
                <mat-label>Min value</mat-label>
                <input matInput type="number" [(ngModel)]="this.PrinterSettings.StandardCopies">
              </mat-form-field>
            </div>

            <div class="fullWidthContainer" style="padding-left: 0.5%;margin-bottom: 20px;">
              <mat-slide-toggle [(ngModel)]="this.PrinterSettings.IsTestEnviorment">{{'IsTestEnviorment' | translate}}</mat-slide-toggle>
            </div>

            <div class="fullWidthContainer" style="padding-left: 0.5%;" *ngIf="this.PrinterSettings?.UserID?.length > 0 && this.PrinterSettings?.ID?.length > 0;">
              <mat-slide-toggle (change)="toggleUsePersonalAutoPrintSettings($event)" [(ngModel)]="this.parent.User.Settings.UsePersonalAutoPrintSettings">{{'UsePersonalAutoPrintSettings' | translate}}</mat-slide-toggle>
            </div>

          </div>

          <div class="fullWidthContainer" style="padding-left: 2.5%;margin-bottom: 10px;">
            <div class="halfWidth">
              <button mat-raised-button color="accent" (click)="AddUpdatePrinterSettings(this.PrinterSettings);">{{'SaveButton' | translate}}</button>
            </div>
          </div>

          <div class="fullWidthContainer" style="padding-left: 2.5%;margin-bottom: 10px;" *ngIf="this.PrinterSettings?.UserID?.length > 0 && this.PrinterSettings.ID == null;">
            <div class="halfWidth">
              <button mat-raised-button color="primary" (click)="CancelPersonalPrinterSettings();">{{'Cancel' | translate}}</button>
            </div>
          </div>

          <div class="fullWidthContainer" style="padding-left: 2.5%;margin-bottom: 10px;" *ngIf="this.PrinterPersonalSettingsExistance == false;">
            <div class="halfWidth">
              <button mat-raised-button color="primary" (click)="InitializePersonalPrinterSettings(this.PrinterSettings);">
                <i class="material-icons">add</i>
                {{'AddPersonalSettings' | translate}}
              </button>
            </div>
          </div>

        </mat-tab>
        <mat-tab label="{{ 'DeleteDataSettings' | translate }}"> 
          <div class="fullWidthContainer" *ngIf="loading" style="margin-top: 5%;">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>

          <div class="MainTabBody" *ngIf="!loading">
           
            <div class="FifteenPercentContainer">
              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
                <mat-select name="Period" [(ngModel)]="Filter.Period">
                  <mat-option *ngFor="let a of this.AccountingMasterData.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period');">
                    {{a.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="FifteenPercentContainer">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
                <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                <mat-datepicker #dp></mat-datepicker>
              </mat-form-field>
            </div>
           
            <div class="FifteenPercentContainer">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
                <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
                <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                <mat-datepicker #dp1></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="DeletingDocumentContainer" *ngFor="let d of this.DeletingDocuments; index as i">
              <mat-checkbox class="example-margin" [(ngModel)]="d.IsSelected">{{d.Name}}</mat-checkbox>
            </div>
          </div>

          <div class="fullWidthContainer" style="padding-left: 2.5%;margin-bottom: 10px;">
            <div class="halfWidth">
              <button class="DeleteButton" mat-raised-button color="warn" (click)="GetDeletingEntitiesCount();">{{'DeleteDataButton' | translate}}</button>
            </div>
          </div>

          <div class="fullWidthContainer" style="padding-left: 2.5%;margin-bottom: 10px;">
            <div class="halfWidth">
              <button class="DeleteButton" mat-raised-button color="warn" (click)="OpenMFACompanyDelete();">{{'DeleteWholeCompany' | translate}}</button>
            </div>
          </div>

        </mat-tab>
        <mat-tab label="{{ 'EFacturaSettings' | translate }}">
          
        <div class="halfWidth">
          <div *ngIf="this.EFacturaGeneralData != null;" class="EFacturaSettingsContainer">
            <div class="fullWidthContainer">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>{{ 'CompanyName' | translate }}</mat-label>
                <input disabled matInput [(ngModel)]="this.Company.Name">
              </mat-form-field>
            </div>
  
            <div class="fullWidthContainer">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>{{ 'CallBackUrl' | translate }}</mat-label>
                <input disabled matInput [(ngModel)]="this.EFacturaGeneralData.CallBackUrl">
              </mat-form-field>
            </div>
  
            <div class="fullWidthContainer">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>{{ 'ClientID' | translate }}</mat-label>
                <input disabled matInput [(ngModel)]="this.EFacturaGeneralData.ClientID">
              </mat-form-field>
            </div>
  
            <div class="fullWidthContainer">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>{{ 'ClientSecret' | translate }}</mat-label>
                <input disabled matInput [(ngModel)]="this.EFacturaGeneralData.ClientSecret">
              </mat-form-field>
            </div>
  
            <div class="fullWidthContainer">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>{{ 'EToken' | translate }}</mat-label>
                <input disabled matInput [(ngModel)]="this.EFacturaGeneralData.EToken">
              </mat-form-field>
            </div>

            <div class="fullWidthContainer">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>{{ 'RefreshToken' | translate }}</mat-label>
                <input disabled matInput [(ngModel)]="this.EFacturaGeneralData.RefreshToken">
              </mat-form-field>
            </div>

            <div class="fullWidthContainer">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>{{ 'AuthCode' | translate }}</mat-label>
                <input disabled matInput [(ngModel)]="this.EFacturaGeneralData.AuthCode">
              </mat-form-field>
            </div>
  
            <div class="fullWidthContainer">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>{{ 'ETokenExpiration' | translate }}</mat-label>
                <input disabled matInput [(ngModel)]="this.EFacturaGeneralData.ETokenExpirationUI">
              </mat-form-field>
            </div>

            <div class="fullWidthContainer">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>{{ 'SigningUser' | translate }}</mat-label>
                <input disabled matInput [(ngModel)]="this.EFacturaGeneralData.SigningUser.UIName">
              </mat-form-field>
            </div>
          </div>

          <div class="fullWidthContainer LifeSpanContainer" *ngIf="this.EFacturaGeneralData?.ETokenLifespanList != null">
            <p class="LifeSpanTitle">{{this.EFacturaGeneralData?.DaysUntilExpiration}} {{'DaysUntilExpiry' | translate}}</p>
            
            <div *ngIf="this.EFacturaGeneralData?.ETokenLifespanList?.length > 10" class="LifeSpanUnitbackground">
              <div class="LifeSpanUnit" *ngFor="let unit of this.EFacturaGeneralData.ETokenLifespanList; let i=index;">
              </div>
            </div>
            
            <div *ngIf="this.EFacturaGeneralData?.ETokenLifespanList?.length <= 10 && this.EFacturaGeneralData?.ETokenLifespanList?.length > 5" class="LifeSpanUnitbackground">
              <div style="background: gold;" class="LifeSpanUnit" *ngFor="let unit of this.EFacturaGeneralData.ETokenLifespanList; let i=index;">
              </div>
            </div>

            <div *ngIf="this.EFacturaGeneralData?.ETokenLifespanList?.length <= 5 && this.EFacturaGeneralData?.ETokenLifespanList?.length > 3" class="LifeSpanUnitbackground">
              <div style="background: #f60;" class="LifeSpanUnit" *ngFor="let unit of this.EFacturaGeneralData.ETokenLifespanList; let i=index;">
              </div>
            </div>
              
            <div *ngIf="this.EFacturaGeneralData?.ETokenLifespanList?.length <= 3" class="LifeSpanUnitbackground">
              <div style="background: #fd4f57;" class="LifeSpanUnit" *ngFor="let unit of this.EFacturaGeneralData.ETokenLifespanList; let i=index;">
              </div>
            </div>

            <button style="margin-top: 20px;" [disabled]="this.parent.loading" mat-raised-button color="primary" (click)="this.ShowANAFRedirectionNotification = true;">
              <i class="material-icons">lock_reset</i>
              {{ 'ResetToken' | translate }}
            </button>
          </div>
        </div>

        <div class="halfWidth" style="padding-top: 20px;">
          <div class="EFacturaSettingSlideContainer">
            <mat-slide-toggle [(ngModel)]="this.EFacturaSettings.EFacturaAutomaticSend" matTooltip="{{ 'EFacturaAutomaticSendDesc' | translate }}" matTooltipClass='neutral-tool-tip'>{{'EFacturaAutomaticSend' | translate}}</mat-slide-toggle>
          </div>
          
          <div class="EFacturaSettingSlideContainer">
            <mat-slide-toggle [(ngModel)]="this.EFacturaSettings.EFacturaAutomaticReceive" matTooltip="{{ 'EFacturaAutomaticReceiveDesc' | translate }}" matTooltipClass='neutral-tool-tip'>{{'EFacturaAutomaticReceive' | translate}}</mat-slide-toggle>
          </div>

          <div class="EFacturaSettingSlideContainer">
            <button style="margin-top: 20px;" [disabled]="this.parent.loading" mat-raised-button color="primary" (click)="AddUpdateCompanyEFacturaSettings();">
              <i class="material-icons">check</i>
              {{ 'Update' | translate }}
            </button>
          </div>
         
        </div>

        </mat-tab>
      </mat-tab-group>
</div>